import { render } from "./formField.vue?vue&type=template&id=1ed800d1&scoped=true"
import script from "./formField.vue?vue&type=script&lang=js"
export * from "./formField.vue?vue&type=script&lang=js"

import "./formField.vue?vue&type=style&index=0&id=1ed800d1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ed800d1"]])

export default __exports__